/** The api-rs error body's `console_msg`, when the failure is an HTTP response
 *  carrying one; otherwise undefined so callers fall back to their own copy. */
export function consoleMsgFrom(err: unknown): string | undefined {
  if (typeof err !== "object" || err === null || !("response" in err)) {
    return undefined;
  }
  const data = (err as { response?: { data?: unknown } }).response?.data;
  if (typeof data !== "object" || data === null || !("console_msg" in data)) {
    return undefined;
  }
  const msg = (data as { console_msg?: unknown }).console_msg;
  return typeof msg === "string" && msg.length > 0 ? msg : undefined;
}
